import { render, staticRenderFns } from "./CabecalhoCadastro.vue?vue&type=template&id=3b5b05b2"
import script from "./CabecalhoCadastro.vue?vue&type=script&lang=js"
export * from "./CabecalhoCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports